import { getRequest } from 'utils/api/apiRequest'

export type SocialWallUserResponse = {
  social_wall_user: {
    available_recognitions: number
  }
}

export const getSocialWallUser = () => getRequest<SocialWallUserResponse>(`/social-wall/user`)
